import Vue from 'vue'
import ElementUI from 'element-ui'
import * as VueGoogleMaps from 'vue2-google-maps'
import locale from 'element-ui/lib/locale/lang/en'
import dayjs from 'dayjs'
import id from 'dayjs/locale/id'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.scss'

import keys from '../keys'

import currencyinput from './components/Common/CurrencyInput.vue'
import PhoneNumberInput from './components/Common/PhoneNumberInput.vue'

import * as services from './providers/services'
import * as strings from './assets/strings'
import { directive as onClickOutside } from 'vue-on-click-outside'
Vue.directive('on-click-outside', onClickOutside)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.component('currencyinput', currencyinput)
Vue.component('PhoneNumberInput', PhoneNumberInput)

if (process.env.VUE_APP_API_TARGET === 'production') {
  console.log = () => { }
}
console.log('process.env.VUE_APP_API_TARGET', process.env.VUE_APP_API_TARGET)

Vue.prototype.$_services = services
Vue.prototype.$_strings = strings

Vue.use(VueGoogleMaps, {
  load: {
    key: keys().googleMapsApiKey
  }
})

dayjs.locale(id) // use loaded locale globally

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
